import styled from 'styled-components';
import { Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import PlainHorizontalCard, {
	PlainHorizontalCardPadding,
} from 'packages/kakapo-ui-kit/components/cards/PlainHorizontalCard';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import FormErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/FormErrorMessage';

interface IProps {
	error: Error;
	title?: string;
}

const Element = styled.div`
	img {
		width: 600px;
		max-width: 100%;
	}
`;

export default function ErrorStateCard({ error, title }: IProps) {
	const { t } = useTranslation();

	return (
		<PlainHorizontalCard padding={PlainHorizontalCardPadding.Large}>
			<Element>
				<Flex alignItems="center" flexDirection="column">
					<Column p={3} textAlign="center">
						<SectionTitle>{title ?? t('common.errorState.pageTitle')}</SectionTitle>
						<FormErrorMessage error={error} />
					</Column>
				</Flex>
			</Element>
		</PlainHorizontalCard>
	);
}
